interface IWorkItemsIconProps {
  className?: string;
}

/**
 * An inbox tray with an item dropping in — work items are units of work raised
 * into a held queue. The tray silhouette keeps it apart from the document and
 * framed-list icons on neighboring tiles. Monoline, `currentColor`, no fills.
 * Sized on a 48×48 grid.
 */
const WorkItemsIcon = ({ className }: IWorkItemsIconProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 48 48"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
    className={className}
    aria-hidden="true"
  >
    {/* tray */}
    <path d="M8 27 h9 l4 5 h6 l4 -5 h9 v11 a2 2 0 0 1 -2 2 H10 a2 2 0 0 1 -2 -2 z" />
    {/* item dropping in */}
    <path d="M24 7 v12" />
    <path d="M19 15 l5 5 5 -5" />
  </svg>
);

export default WorkItemsIcon;
